(ns app.front.view.group.subs
  "Frontend re-frame subscriptions that get the group in question as parameter.
  Other group related subs should be placed elsewhere (preferably next to their group source)
  to prevent dependency cycles and muddled namespace organization."
  (:require [app.domain.group.model :as group-model]
            [app.front.entities :as entities]
            [re-frame.core-instrumented :as rf]))


(defn handle-entities-for-group [[group-id ctx] _]
  (entities/find-entities ctx {:domain/authority-group group-id}))


(rf/reg-sub ::available-qualifications
  :<- [::entities/entities {:entity/type :entity.type/group}]
  (fn [groups [_ authority-group-id]]
    (->> groups
         (filter #(and (contains? (set (:group/roles %)) :group.role/inspector)
                       (= authority-group-id (-> %
                                                 :entity/parent ;inspector group
                                                 :entity/parent ;authority group
                                                 :db/id))))
         (keep :group/inspector-qualification))))


(rf/reg-sub ::available-party-roles
  (fn [[_ authority-group-id]]
    (rf/subscribe [::entities/entities {:entity/type                :entity.type/party-role
                                        :party-role/authority-group authority-group-id}]))
  :-> identity)

(defn filter-party-roles [authority-group-ids permit-type party-roles]
  (->> party-roles
       (filter #(let [authority-group (group-model/get-authority-group %)]
                  (and (contains? authority-group-ids (:db/id authority-group))
                       (contains? (group-model/get-permit-types authority-group) permit-type))))))

(rf/reg-sub ::descendant-available-party-roles
  :<- [::entities/entities {:entity/type :entity.type/party-role}]
  (fn [party-roles [_ authority-group-ids permit-type]]
    (filter-party-roles authority-group-ids permit-type party-roles)))

(rf/reg-sub ::has-feature?
  (fn [[_ group-id]]
    (rf/subscribe [::entities/entity group-id]))
  (fn [group [_ _ feature]]
    (contains? (:group/features group) feature)))
